export enum SignatureStatuses {
  Created = 'created',
  Waiting = 'waiting',
  Signed = 'signed',
  Declined = 'declined',
  Bounced = 'bounced_email',
  Cancelled = 'cancelled',
}
